import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, custom }: Theme) => ({
  root: {
    backgroundColor: custom.grey[0],
    color: custom.grey[2],
    display: 'inline-flex',
    borderRadius: 4,
    alignItems: 'center',
    padding: '5px 10px',
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 400,
    lineHeight: 1.43,
    cursor: 'pointer',
    '&:focus': {
      backgroundColor: custom.grey[3],
      color: palette.common.white,
      borderColor: custom.grey[3],
    },
    '&$focus': {
      backgroundColor: custom.grey[3],
      borderColor: custom.grey[3],
    },
  },
  label: {
    marginRight: 3,
    whiteSpace: 'normal',
    display: 'flex',
    alignItems: 'center',
  },
  closeIcon: {
    cursor: 'pointer',
    fontSize: 14,
  },
  focus: {},
}));
